import { useEffect, useState } from 'react';

let blockedRequestPromise: Promise<boolean> | null = null;

const getBlockedRequestResult = (): Promise<boolean> => {
  if (!blockedRequestPromise) {
    blockedRequestPromise = fetch('/xas/api/agencies.json')
      .then(() => false)
      .catch(() => true);
  }

  return blockedRequestPromise;
};

export const resetAdBlockDetectionForTests = (): void => {
  blockedRequestPromise = null;
};

// Match XAM's AdBlockDetect checks without rendering its dialog.
export const useAdBlockDetection = (): {
  adBlockDetected: boolean;
  isLoading: boolean;
} => {
  const [detected, setDetected] = useState<boolean>();

  useEffect(() => {
    let isActive = true;
    const bait = document.createElement('div');
    bait.className = 'ads-banner';
    bait.setAttribute('aria-hidden', 'true');
    bait.style.cssText =
      'position:absolute;bottom:-100px;left:-100px;width:1px';
    document.body.appendChild(bait);

    // XAM probes /xas/, which is targeted by ad blocker filter lists.
    const requestResult = getBlockedRequestResult();
    const isBlockedElement = bait.offsetParent === null;
    if (isBlockedElement) setDetected(true);

    void requestResult.then((isBlockedRequest) => {
      if (isActive) {
        setDetected(
          isBlockedElement || bait.offsetParent === null || isBlockedRequest
        );
      }
    });

    return () => {
      isActive = false;
      bait.remove();
    };
  }, []);

  return {
    adBlockDetected: detected ?? false,
    isLoading: detected === undefined,
  };
};
